export default "__VITE_ASSET__Da8uo0ld__"